/*global translate*/
import React, { Component } from 'react'
import { connect } from 'react-redux'

const { changeColorSVG } = global.rootRequire('classes/ulti')

global.isclient && require('./rxMessMenu.css')

const chatDB = global.rootRequire('classes/indexedDB').default
const rxio = global.rootRequire('classes/socket').default
const workerUnread = global.rootRequire('classes/globalUnread')
const { changeGroupFunc } = global.rootRequire('redux')

class RxModalEdit_ extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {}
    }

    chooseOptionMenu(e) {
        let arrResults = []
        chatDB.groups.filter(oGroup => (oGroup.count_unread > 0)).each(groupTmp => {
            let lastMessageId = (groupTmp && groupTmp.last_message && groupTmp.last_message.message_id) ? groupTmp.last_message.message_id : groupTmp.last_message_id || ''
            if (lastMessageId) {
                workerUnread.initUnread(groupTmp.group_id.toString(), '-1')
                arrResults.push({ group_id: groupTmp.group_id, mess_id: lastMessageId })
            }
        }).then(async () => {
            await chatDB.groups.filter(oGroup => (oGroup.count_unread > 0)).modify((grpTmp) => {
                grpTmp.count_unread = 0
                grpTmp.my_seen_mess = (grpTmp && grpTmp.last_message && grpTmp.last_message.message_id) ? grpTmp.last_message.message_id : grpTmp.last_message_id || ''
            })

            if (arrResults && arrResults.constructor === Array && arrResults.length > 0) {
                await this.delay(400)
                this.props.changeGroupFunc()
                for (let oParams of arrResults) {
                    await this.delay(400)
                    this.checkReadedOne(oParams.group_id, oParams.mess_id)
                }
            }
        })

        const menuDivMenu = document.getElementById('tab-menu-mess')
        if (menuDivMenu) {
            menuDivMenu.style.display = 'none'
        }

    }

    delay(delayInms) {
        return new Promise(resolve => setTimeout(resolve, delayInms));
    }

    checkReadedOne(group_id, mess_id) {
        const msg = {
            group_id: group_id,
            message_id: mess_id,
            message: '',
            status: 3
        }

        if (rxio.connected) {
            rxio.socket.emit('update_message', msg, (data) => {})
        }
    }

    onClickMouseRight(e) {
        const menuDiv = document.getElementById('tab-menu-mess')
        if (menuDiv && e.button === 2) {
            document.oncontextmenu = function () {
                return false;
            }
            menuDiv.style.top = (Number(e.clientY) - 80) + 'px'
            menuDiv.style.left = (Number(e.clientX) - 40) + 'px'
            menuDiv.style.display = 'block'
        }
    }

    render() {
        return (
            <>
                <div id='tab-menu-mess'>
                    <div className={'tab-menu-mess-box'}>
                        <div className='tab-option-mess-row' onClick={e => this.chooseOptionMenu(e)}>{translate('Mark as read all')}</div>
                    </div>
                </div>

                <div className='zmenu_message' onMouseDown={(e) => this.onClickMouseRight(e)}>
                    <img src={changeColorSVG('./images/default/icons/chat-active.svg')} alt='' className='zmenu_icon icon filter_img_class' />
                </div>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = {
    changeGroupFunc
}

const RxModalEdit = connect(
    mapStateToProps,
    mapDispatchToProps
)(RxModalEdit_)

export default RxModalEdit